export enum PresenceDataModeType {
  PRESENCE_API = 'true',
  SHADOW = 'shadow',
  DEVICE_SEARCH_API = 'false',
}

export interface PresenceDataModeSettings {
  presenceApiEnableMode: PresenceDataModeType;
}
